// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application--wrap{display:none!important}.main-dialog-desktop{border-radius:20px;background-color:var(--v-primary-base)}.main-dialog-mobile{max-height:none!important;border-radius:20px 20px 0 0!important;background-color:var(--v-primary-base)}.margin-bottom-60{margin-bottom:60px!important}.margin-bottom-0{margin-bottom:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
